import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { NAV_LINKS, ROOMS_ROUTE, SITE_NAME } from '@/lib/constants'
import { MobileNav } from './MobileNav'
import type { Customer, HotelProfile } from '../api/types'

export function Header({
  customer,
  onLogout,
}: {
  hotel?: HotelProfile
  customer: Customer | null
  onLogout: () => void
}) {
  const { t } = useTranslation()

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className="fixed top-0 left-0 right-0 z-40 transition-all duration-300"
      style={{ backgroundColor: '#0F2966' }}
    >
      {/* 3-column layout: logo | nav links | CTA — matches hbnuevavalladolid.com exactly */}
      <div className="mx-auto flex h-16 max-w-7xl items-center lg:h-[70px] lg:px-8 px-4">

        {/* Logo — left column */}
        <div className="flex-shrink-0">
          <Link
            to="/"
            className="flex items-center"
            style={{ width: 130, height: 64 }}
            aria-label={SITE_NAME}
          >
            <img
              src="/images/nuva/logo/logo-nav-white.png"
              alt={SITE_NAME}
              className="h-full w-full object-contain"
            />
          </Link>
        </div>

        {/* Nav links — center */}
        <nav className="hidden flex-1 items-center justify-center gap-0 lg:flex">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className="px-[15px] py-2 text-sm font-bold text-white transition-colors hover:text-[#F3EADB]"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              {t(link.labelKey)}
            </Link>
          ))}
        </nav>

        {/* CTA button — right column */}
        <div className="hidden items-center lg:flex">
          <Link
            to={ROOMS_ROUTE}
            className="flex items-center justify-center text-sm font-bold text-white transition-colors hover:text-[#0F2966]"
            style={{
              width: 175,
              height: 50,
              borderRadius: 100,
              backgroundColor: 'transparent',
              border: '1px solid #FFFFFF',
              fontFamily: 'Montserrat, sans-serif',
            }}
            onMouseEnter={(e) => {
              const el = e.currentTarget
              el.style.backgroundColor = '#F3EADB'
              el.style.color = '#0F2966'
              el.style.borderColor = '#F3EADB'
            }}
            onMouseLeave={(e) => {
              const el = e.currentTarget
              el.style.backgroundColor = 'transparent'
              el.style.color = '#FFFFFF'
              el.style.borderColor = '#FFFFFF'
            }}
          >
            {t('nav.book')}
          </Link>
        </div>

        {/* Mobile hamburger */}
        <div className="ml-auto lg:hidden" style={{ color: '#FFFFFF' }}>
          <MobileNav customer={customer} onLogout={onLogout} />
        </div>
      </div>
    </motion.header>
  )
}
